import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import copyToClipboard from 'copy-to-clipboard';
import { t } from 'utils/translates';

import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';

class ReferralLinkPanel extends Component {
  constructor(props) {
    super(props);
    const domain = document.location.origin;
    const urlParam = `?ref=${props.authUserId}`;
    this.state = {
      domain,
      urlParam,
      referralUrl: `${domain}/${urlParam}`
    };
  }

  copyToClipboard = () => {
    copyToClipboard(this.state.referralUrl);
    this.props.addClientNotice({
      type: 'success',
      message: t('Ссылка скопирована в буфер обмена')
    });
  };

  render() {
    return (
      <article className="panel panel-default panel-heading_padding-large panel-body_bg-sub">
        <div className="panel-heading text-center">
          <h2 className="panel-title">
            <i className="fa fa-link fa-lg" />{' '}
            {t('Моя <strong>партнерская ссылка</strong>')}
          </h2>
        </div>
        <div className="panel-body">
          <div className="input-group">
            <label className="control-label sr-only" htmlFor="referralLink">
              {t('Партнерская ссылка')}
            </label>
            <input
              className="form-control"
              id="referralLink"
              name="referralLink"
              readOnly="readonly"
              type="text"
              value={this.state.referralUrl}
            />
            <span className="input-group-btn">
              <button
                className="btn btn-default"
                type="button"
                onClick={this.copyToClipboard}
              >
                <i className="fa fa-clipboard" />
              </button>
            </span>
          </div>
        </div>
        <div className="panel-footer">
          <p className="text-center small text-muted m-t-10">
            {t(
              'Вы можете использовать ссылки на любую страницу сервиса. Достаточно добавить <strong>персональный идентификатор</strong> {urlParam}. Например, тот кто перейдет по ссылке {referralUrl} и зарегистрируется будет так же записан за вами.',
              {
                urlParam: (
                  <code className="text-nowrap">{this.state.urlParam}</code>
                ),
                referralUrl: (
                  <code className="text-nowrap">{this.state.referralUrl}</code>
                )
              }
            )}
          </p>
        </div>
      </article>
    );
  }
}

ReferralLinkPanel.propTypes = {
  authUserId: PropTypes.string.isRequired,
  addClientNotice: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  authUserId: selectUserId(state)
});

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferralLinkPanel);



// WEBPACK FOOTER //
// ./src/components/UserReferral/ReferralLinkPanel/ReferralLinkPanel.js